import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="dealLinkman";

export function deleteLinkman(dealId,linkmanId) {
  return axios({
    url: `/ws/${moduleName}/${dealId}/${linkmanId}`,
    method: 'delete'
  })
}

export function selectByDealId(dealId){
  return axios({
    url: `/ws/${moduleName}/selectByDealId/${dealId}`,
    method: 'get',
  })
}

export function updateLinkmanDOS(pursuitsId, linkmanDOS){
  return axios({
    url: `/ws/${moduleName}/updateLinkmanDOS/${pursuitsId}`,
    method: 'put',
    data: linkmanDOS,
  })
}

export default {
  selectByDealId,
  deleteLinkman,
  updateLinkmanDOS,
}